import { useQuery } from '@tanstack/react-query';
import {
  getEarningsInsightPreview,
  getEarningsInsightPreviewV4,
  QUERY_KEY_EARNINGS_INSIGHT_PREVIEW,
  QUERY_KEY_EARNINGS_INSIGHT_PREVIEW_V4,
} from '@terminal/services/insights/earnings-insights-service';
import {
  createEarningsInsightQueryOptions,
  useEarningsInsightQueries,
} from './useEarningsInsightQueries';

export const useGetEarningsInsightPreview = (earningsInsightId: string) =>
  useQuery(
    createEarningsInsightQueryOptions({
      earningsInsightId,
      queryKey: QUERY_KEY_EARNINGS_INSIGHT_PREVIEW,
      queryFn: getEarningsInsightPreview,
      enabled: !!earningsInsightId,
    })
  );

export const useEarningsInsightPreviews = (earningsInsightIds: string[]) =>
  useEarningsInsightQueries({
    earningsInsightIds,
    queryKey: QUERY_KEY_EARNINGS_INSIGHT_PREVIEW,
    queryFn: getEarningsInsightPreview,
  });

export const useEarningsInsightPreviewsV4 = (earningsInsightIds: string[]) =>
  useEarningsInsightQueries({
    earningsInsightIds,
    queryKey: QUERY_KEY_EARNINGS_INSIGHT_PREVIEW_V4,
    queryFn: getEarningsInsightPreviewV4,
  });
